<h2 class="my-0">Umsatzkennzahlen {{ revenueData().currentMonth }}</h2>
@if (revenueData().updated_at) {
  <p class="text-small">Stand: {{ revenueData().updated_at | date: 'dd.MM.yyyy HH:mm'}}</p>
}

<div class="d-flex mb-s align-items-center" >
  <img src="assets/icons/euro.svg" alt="Euro sign icon">
  <div class="ml-s">
    <span class="small p-0 mb-0">Umsatz total</span><br>
    <span class="text-xlarge">{{ revenueData().total_revenue | currency:'EUR':'symbol':'1.2-2'}}</span>
  </div>
</div>
@if (!hasTargetRxPackets()) {
<div class="d-flex mt-m mb-s align-items-center" >
  <img src="assets/icons/packungen.svg" alt="Package icon">
  <div class="ml-s">
    <span class="small p-0 mb-0">Anzahl RX Packungen <span class="material-symbols-outlined" matTooltip="inkl. Hochpreis">info</span></span><br>
    <span class="text-xlarge">{{ revenueData().rx_packet_count | number}}</span>
  </div>
</div>
}
  <a class="widget-link mt-m" routerLink="/umsatz">Details ></a>

